import {
  mergeSx,
  TableCell,
  TableHead,
  TableRow,
  type TableCellProps as TableHeaderCell,
  type TableHeadProps,
  type TableRowProps,
} from '@shared/components';
import { deepMerge, randomUUID } from '@shared/utils';

export interface TableHeaderRow extends Omit<TableRowProps, 'children'> {
  children: TableHeaderCell[];
}

export interface TableHeaderProps {
  columns: TableHeaderRow[];
  slotProps?: {
    tableHeader?: TableHeadProps;
    tableHeaderRow?: TableRowProps;
    tableHeaderCell?: TableHeaderCell;
  };
}

export default function TableHeader(props: Readonly<TableHeaderProps>) {
  const { columns, slotProps = {} } = props;
  const {
    tableHeader: tableHeaderProps,
    tableHeaderRow: tableHeaderRowProps = {},
    tableHeaderCell: tableHeaderCellProps = {},
  } = slotProps;

  return (
    <TableHead {...tableHeaderProps}>
      {columns.map(({ children, sx, ...headerRow }, index) => {
        const combinedHeaderRowProps = {
          ...deepMerge(tableHeaderRowProps, headerRow),
          sx: mergeSx(tableHeaderRowProps.sx, sx),
        };
        return (
          <TableRow key={index} {...combinedHeaderRowProps}>
            {children.map(({ children, sx, ...cell }) => {
              const combinedHeaderCellProps = {
                ...deepMerge(tableHeaderCellProps, cell),
                sx: mergeSx(tableHeaderCellProps.sx, sx),
              };

              const uuid = randomUUID().substring(0, 4);

              return (
                <TableCell key={`${children}-${uuid}`} {...combinedHeaderCellProps}>
                  {children}
                </TableCell>
              );
            })}
          </TableRow>
        );
      })}
    </TableHead>
  );
}

export type { TableHeaderCell };
